import { PriorityOption, priorityOptionColors } from "./purchasing-priority-utils";

export const PurchasingPriorityBadge: React.FC<{ priority: PriorityOption }> = ({ priority }) => {
  return (
    <span
      className="badge"
      style={{
        backgroundColor: priorityOptionColors[priority],
        color: "var(--bs-dark)",
      }}
    >
      {priority}
    </span>
  );
};
